/* 曹操傳・第 11 章：潼關北渡（211 年）
 * 黃河（潼關以東折向東流）由西往東橫過。曹軍在南岸，要從潼關北渡；南岸江邊有碼頭（淺灘），北岸對面也有一處淺灘能上岸。 */
export const DOCK = [4000, 2900], LANDING = [4000, 1450], CAMP = [4000, 3700];
export default {
  id: 'tongguan', name: '潼關', W: 8000, H: 4800, seed: 211,
  bases: [CAMP, [4000, 800]], // 第二個基地放在北岸：地圖產生器只保留從基地走得到的地方，北岸被河隔開，要有一個基地在那邊
  rivers: [{ pts: [[-100, 2220], [2600, 2180], [5400, 2240], [8100, 2200]], hw: 620, fords: [] }],
  roads: [{ pts: [CAMP, [DOCK[0], DOCK[1] + 200]], w: 130 }, { pts: [[LANDING[0], LANDING[1] - 150], [4000, 700]], w: 120 }, { pts: [CAMP, [6000, 3800], [7400, 3900]], w: 130 }],
  rocks: [[1600, 3800, 420, 200], [6400, 1000, 420, 200], [1800, 900, 400, 190], [6400, 4300, 380, 180]],
  woods: 0.4,
  sight: 0.8,
  clearings: [[CAMP[0], CAMP[1], 600], [DOCK[0], DOCK[1] + 250, 380], [LANDING[0], LANDING[1] - 200, 340], [7400, 3900, 400]],
  marsh: [[DOCK[0], DOCK[1] - 20, 240, 120], [LANDING[0], LANDING[1] + 30, 240, 120]],
  tents: [{ x: CAMP[0], y: CAMP[1], n: 6, r: 420, col: '#3b5a99', flag: '曹' }, { x: 7400, y: 3900, n: 7, r: 420, chief: true, col: '#5a6a3a', flag: '馬' }],
};
